import React, { useState, useEffect, useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { CloseOutlined, QrcodeOutlined } from "@ant-design/icons";
import "./FloatingQRCode.css";

function FloatingQRCode({ url = "https://www.slytekinc.com/", username }) {
  const [isMinimized, setIsMinimized] = useState(false);
  const qrContainerRef = useRef(null);

  // Handle click outside to minimize
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        qrContainerRef.current &&
        !qrContainerRef.current.contains(event.target) &&
        !isMinimized
      ) {
        setIsMinimized(true);
      }
    };

    // Add event listener when QR code is expanded
    if (!isMinimized) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMinimized]);

  // Only show for user 'cam'
  if (username !== "cam for tradeshows") {
    return null;
  }

  return (
    <div
      ref={qrContainerRef}
      className={`floating-qr-container ${isMinimized ? "minimized" : ""}`}
    >
      {!isMinimized ? (
        <>
          <div className="qr-header">
            <span className="qr-title">Scan here for info</span>
            <CloseOutlined
              className="qr-close-btn"
              onClick={() => setIsMinimized(true)}
            />
          </div>
          <div className="qr-body">
            <QRCodeSVG
              value={url}
              size={150}
              level="H"
              includeMargin={true}
              bgColor="#ffffff"
              fgColor="#000000"
            />
            <a
              className="qr-url"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              {url}
            </a>
          </div>
        </>
      ) : (
        <div
          className="qr-minimized-btn"
          onClick={() => setIsMinimized(false)}
          title="Show QR Code"
        >
          <QrcodeOutlined style={{ fontSize: 24 }} />
        </div>
      )}
    </div>
  );
}

export default FloatingQRCode;

